
export const qs = (selector, ctx = document) => ctx.querySelector(selector)

export const qsa = (selector, ctx = document) => Array.from(ctx.querySelectorAll(selector))

const domHasClass = (t, e) => {
  return t.classList ? t.classList.contains(e) : new RegExp('(^| )' + e + '( |$)', 'gi').test(t.className)
}

export const domAddClass = (t, e) => {
  if (t.classList) {
    t.classList.add(e)
  } else {
    if (!domHasClass(t, e)) {
      t.className += ' ' + e
    }
  }
}

export const domRemoveClass = (t, e) => {
  if (t.classList) {
    t.classList.remove(e)
  } else {
    t.className = t.className.replace(new RegExp('(^|\\b)' + e.split(' ').join('|') + '(\\b|$)', 'gi'), '')
    var i = t.className.length - 1
    if (t.className[i] === ' ') {
      t.className = t.className.substring(0, i)
    }
  }
}
